import React, { Component } from "react";
import { Container, Header, Icon, Table } from "semantic-ui-react";
import WodRemaining from "../../services/wodremaining";
// import jobsort from "../../services/jobsort";
class AssignedJobsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wods: [],
      jobs: []
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.wods !== this.state.wods) {
      this.setState({ wods: this.props.wods });
    }
  }
  genHeader() {
    if (this.props.mobile != true) {
      return (
        <Table.HeaderCell colSpan="5">
          <Header as="h3">
            <Icon color="black" name="suitcase" /> Assigned Jobs
          </Header>
        </Table.HeaderCell>
      );
    }
  }

  genJob() {
    if (
      this.props.myinfo &&
      this.props.myinfo.assigned &&
      this.props.myinfo.assigned.length
    ) {
      let wods = this.props.myinfo.assigned.map(ass => ass.workorder);
      console.log("MY Assignments", this.props.myinfo.assigned);
      return this.props.myinfo.assigned.map(job => {
        let wod = job.workorder;
        let cssid = WodRemaining(wod) > 0 ? "positivevalue" : "negativevalue";
        let jobrate = job.salarycode.payrate;
        if (jobrate && wod.workOrderNbr !== "20-0003") {
          return (
            <Table.Row>
              <Table.Cell textAlign="center">{wod.workOrderNbr}</Table.Cell>
              <Table.Cell>{wod.description}</Table.Cell>
              <Table.Cell id={cssid} textAlign="center">
                {(WodRemaining(wod) / jobrate).toFixed(0)}
              </Table.Cell>
              <Table.Cell>
                <a color="blue">Update</a>
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    } else {
      return <h3>Not assigned yet</h3>;
    }
  }

  render() {
    return (
      <Container className="AssignedJobs" id="jobstable">
        <Table columns={5} basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="5">
                {this.genHeader()}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign="center">WO #</Table.HeaderCell>
            <Table.HeaderCell>Job Description</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">
              Hours Remaining
            </Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
          {this.genJob()}
        </Table>
      </Container>
    );
  }
}

export default AssignedJobsCard;



// WEBPACK FOOTER //
// ./src/components/home-components/assignedjobs.js